import {
  defaultReview,
  defaultReviewPending,
  defaultReviewSummary,
  IBadge,
  IImage,
  IReview,
  IReviewImageList,
  IReviewPending,
  IReviewSummary,
  MedalType,
  TopReviewType,
} from '@ugc-components/ugc-pdp-review/interface';

interface IReviewState {
  isShowReviewLearnMoreModal: boolean;
  isShowPendingReview: boolean;
  isShowVerifiedPurchase: boolean;
  isShowRewardedReview: boolean;

  // review list data
  isReviewLoading: boolean;
  isReviewListLoaded: boolean;
  isShowReviewSkeleton: boolean;
  ids: string[];
  reviewBreakUpById: { [key: string]: IReview };
  reviewTotalCount: number;

  // review Summary data
  isShowReviewSummaryModal: boolean;
  reviewSummaryModalType: TopReviewType;
  reviewSummary: IReviewSummary;

  // badge data
  isShowMedalModal: boolean;
  medalModalData: IBadge;

  // review pending
  isUpdateReview: boolean;
  userReviewData: IReviewPending;

  // review images section
  reviewImageListData: IReviewImageList;
  imagePagination: {
    current: number;
    pages: number;
    nextPageToken: number;
  };

  //show all images modal:DT & MW
  isShowCustomerImagesModal: boolean;
  dtAllCustomerImagesData: {
    [key: number]: IImage[];
  };
  dtAllImagesPagination: {
    current: number;
    pages: number;
  };

  // all images detail modal
  isShowCustomerAllImagesDetailModal: boolean; //click image of review images section : DT & MW
  customerImagesDetailModalData: IReview;
  activeImageReviewId: string;
  activeImageAssetId: string;

  // click image of review item content : DT & MW
  isShowReviewImageModal: boolean;
  reviewImageModalData: IReviewImageModalData;

  //review cms data
  reviewStaticLanguage: {
    [key: string]: string;
  };
}

interface IReviewImageModalData {
  reviewItem: IReview;
  imageActiveIndex: number;
}

const reviewState: IReviewState = {
  isShowReviewLearnMoreModal: false,
  isShowPendingReview: false,
  isShowVerifiedPurchase: false,
  isShowRewardedReview: false,

  // review list data
  isReviewLoading: false,
  isShowReviewSkeleton: false,
  isReviewListLoaded: false,
  ids: [],
  reviewBreakUpById: {},
  reviewTotalCount: 0,

  // review Summary data
  isShowReviewSummaryModal: false,
  reviewSummaryModalType: TopReviewType.TopPositiveReview,
  reviewSummary: defaultReviewSummary,

  // badge data
  isShowMedalModal: false,
  medalModalData: {
    type: MedalType.Gold,
    name: '',
    description: '',
    title: '',
  },

  // review pending
  isUpdateReview: false,
  userReviewData: defaultReviewPending,

  // review images section
  reviewImageListData: {
    items: [],
    totalCount: 0,
  },
  imagePagination: {
    current: 1,
    pages: 1,
    nextPageToken: 1,
  },

  //show all images modal:DT & MW
  isShowCustomerImagesModal: false,
  dtAllCustomerImagesData: {},
  dtAllImagesPagination: {
    current: 1,
    pages: 1,
  },

  // all images detail modal
  isShowCustomerAllImagesDetailModal: false, //click image of review images section : DT & MW
  customerImagesDetailModalData: defaultReview,
  activeImageReviewId: '',
  activeImageAssetId: '',

  // click image of review item content : DT & MW
  isShowReviewImageModal: false,
  reviewImageModalData: { reviewItem: defaultReview, imageActiveIndex: 0 },

  //review cms data
  reviewStaticLanguage: {},
};

export default reviewState;
